<template>
  <div class="checkBoxWrapper">

    <svg v-if="isChecked" t="1664097642146" class="icon" viewBox="0 0 1024 1024" version="1.1"
      xmlns="http://www.w3.org/2000/svg" p-id="2265" width="48" height="48">
      <path
        d="M512 960C264.577 960 64 759.424 64 512S264.577 64 512 64s448 200.576 448 448-200.577 448-448 448z m246.632-610.632c-12.491-12.491-32.742-12.491-45.233 0L456 606.767 310.601 461.368c-12.491-12.491-32.742-12.491-45.233 0s-12.491 32.742 0 45.233l167.703 167.703c0.104 0.107 0.191 0.223 0.297 0.328 6.249 6.249 14.441 9.372 22.632 9.368 8.191 0.004 16.383-3.118 22.632-9.368 0.106-0.105 0.193-0.222 0.297-0.328l279.703-279.703c12.491-12.491 12.491-32.742 0-45.233z"
        p-id="2266" fill="#2363E8"></path>
    </svg>

    <div v-else>
    </div>
  </div>
</template>
<script>
export default {
  name: "Checkbox",
  props: {
    isChecked: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data () {
    return {

    }
  },
  watch: {},
  computed: {},
  methods: {},
  mounted () {

  },
  created () {

  }
}
</script>

<style lang="less" scoped>
.checkBoxWrapper {
  width: 48px;
  height: 48px;
  div {
    width: 44px;
    height: 44px;
    background: #FFFFFF;
    border: 2px solid #9E9E9E;
    border-radius: 50%;
  }

  svg{
    width:100%;
    height:100%;
  }

}
</style>